import { supertypeClass } from '@haventech/amorphic';
import { WsClient } from './WsClient';

@supertypeClass({ toClient: ['admin'], toServer: true })
export class RestJsonWsClient extends WsClient {
  static new(opts, svcCfg, requestName, requestGroup?) {
    return new RestJsonWsClient(requestName, requestGroup).init(opts, svcCfg);
  }

  init(opts, svcCfg) {
    super.init(opts, svcCfg);
    return this;
  }

  _addHeaders(headers) {
    super._addHeaders(headers);
    headers['content-type'] = 'application/json';
  }

  _parseResponse(str) {
    try {
      return JSON.parse(str || '""');
    } catch (e) {
      return {
        response: str,
      };
    }
  }

  _buildRequest(obj) {
    return JSON.stringify(obj);
  }

  _buildResponse(obj) {
    return JSON.stringify(obj);
  }
}
